import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { deleteUser, userQueryKeys } from '../api/users.api';

export function useDeleteUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => deleteUser(id),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: userQueryKeys.all() });
      toast.success('User deleted successfully');
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to delete user');
    },
  });
}
